import {
  PROJECT_PIPELINES,
  DEFAULT_PIPELINE,
} from "../config/projectPipelines";
import { LuCheck } from "react-icons/lu";

export default function WorkflowStatus({
  label,
  disabled,
  show,
  fontSize = "10px",
  pipelineName,
  showCheck = false,
  isDarkMode = false,
}) {
  // Status colors for all possible statuses across pipelines
  const statusColors = {
    Not_Started: isDarkMode ? "#292929" : "#EEEEEE",
    First_Review: isDarkMode ? "#2A0A0A" : "#FEECF4",
    QA_Review: isDarkMode ? "#3C1E09" : "#E8E6FF",
    Compliance: isDarkMode ? "#222255" : "#E5F3FF",
    Publication: isDarkMode ? "#0D2E19" : "#E6FFF1",

    // Human Perfect / First Draft pipeline
    Speaker_Final: "#FFE9D6",
    FD_Final: "#E5F3FF",
    Human_Final: isDarkMode ? "#0D2E19" : "#E6FFF1",
  };

  const textColors = {
    Not_Started: isDarkMode ? "#ACB1B9" : "#5F646E",
    First_Review: isDarkMode ? "#C75289" : "#C13E7B",
    QA_Review: isDarkMode ? "#E38A49" : "#3D3883",
    Compliance: isDarkMode ? "#7271FF" : "#185B96",
    Publication: isDarkMode ? "#16A34A" : "#178C4A",

    // Human Perfect / First Draft pipeline
    Speaker_Final: "#D45719",
    FD_Final: "#185B96",
    Human_Final: isDarkMode ? "#16A34A" : "#178C4A",
  };

  // Get the display name for a status based on the workflow data
  const getStatusDisplayName = (status, pipelineName) => {
    // Get pipeline from provided pipeline name or use default
    const pipeline = PROJECT_PIPELINES[pipelineName || DEFAULT_PIPELINE];
    return pipeline?.statusMap?.[status] || status.replace(/_/g, " ");
  };

  if (show) {
    return (
      <span
        style={{
          display: "inline-flex",
          fontSize,
          fontWeight: 500,
          textTransform: "uppercase",
          padding: "4px 8px",
          color: disabled ? "#94979F" : textColors[label],
          backgroundColor: disabled
            ? isDarkMode
              ? "#292929"
              : "#F2F2F6"
            : statusColors[label],
          borderRadius: "6px",
          lineHeight: 1.2,
        }}
      >
        {showCheck && (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              marginRight: 4,
            }}
          >
            <LuCheck
              width={12}
              height={12}
              color={"#94979F"}
              strokeWidth={4}
            />
          </span>
        )}

        {getStatusDisplayName(label, pipelineName)}
      </span>
    );
  }

  return null;
}
